import { render, staticRenderFns } from "./dashboard-toggle-bar.vue?vue&type=template&id=568c039c&"
import script from "./dashboard-toggle-bar.vue?vue&type=script&lang=js&"
export * from "./dashboard-toggle-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports